import Layout from "@molteo-ui/Layout/Layout";
import LoadingScreen from "@molteo-ui/LoadingScreen/LoadingScreen";
import BauGPT from "components/BauGPT";
import Maintenance from "components/Maintenance";
import { ENV, isDev } from "constants/env";
import { GetStaticProps, InferGetServerSidePropsType } from "next";
import { useRouter } from "next/router";
import { StoryParams } from "storyblok-js-client";
import { getFullSlug } from "utils/router.helper";
import Storyblok from "utils/storyblok";

const DEFAULT_FOLDER_SLUG = "poliergpt";

export type TranslatedSlugDef = {
  path: string;
  lang: string;
};


export default function Page({
  slug,
  locale,
  locales,
  settings,
}: InferGetServerSidePropsType<typeof getStaticProps>) {
  const router = useRouter();
  // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running
  if (router.isFallback) {
    return <LoadingScreen />;
  }

  // get default slug and translated slugs from story
  // get default slug and translated slugs from story
  const translatedSlugs: TranslatedSlugDef[] = (locales as any).map((lang) => ({
    path: getFullSlug(slug, DEFAULT_FOLDER_SLUG),
    lang,
  }));

  if (ENV.MAINTENANCE === "true") {
    return <Maintenance />;
  }

  return (
    <Layout
      locale={locale}
      translatedSlugs={translatedSlugs}
      deactivateSupportChat
      settings={settings}
    >
      <BauGPT locale={locale} />
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale, locales }) => {
  const sbParams: StoryParams = {
    version: "published",
    language: locale,
    resolve_links: "url",
    cv: Date.now(),
  };

  if (isDev()) {
    sbParams.version = "draft";
  }

  let settings;

  try {
    // Fetch Global settings
    const settingsData = await Storyblok.get(`cdn/stories/settings`, sbParams);
    settings = settingsData?.data?.story?.content || null;
  } catch (err) {
    console.error("[storyblok]", err.response?.data);
    return { notFound: true };
  }

  if (ENV.MAINTENANCE === "true") {
    return {
      props: {
        slug: DEFAULT_FOLDER_SLUG,
        locale,
        locales,
        settings,
      },
      revalidate: 60, // revalidate every minute
    };
  }

  return {
    props: {
      slug: DEFAULT_FOLDER_SLUG,
      locale,
      locales,
      settings,
    },
  };
};
